import { createPortal } from 'react-dom';
import { createStoreHooks, type FeatureDeps } from '../../core';
import {
  coordinates,
  getCoordinateTransformContext,
} from '../../core/coordinate-system';
import { normalizeRectangle } from '../../core/utils';
import { createAutoPanFeature } from '../auto-pan';
import { createRectangleSelectionFeature } from './feature';

type SelectionOverlayDeps = FeatureDeps<
  [typeof createAutoPanFeature, typeof createRectangleSelectionFeature]
>;

const { useStore: useSelector } = createStoreHooks<SelectionOverlayDeps>();

export const SelectionOverlay = () => {
  const selectionState = useSelector(s => s.rectangleSelection.state);
  const canvasState = useSelector(s => s.canvas);
  const transformCtx = getCoordinateTransformContext(canvasState);

  if (
    !selectionState.isActive ||
    !selectionState.startPoint ||
    !selectionState.currentPoint ||
    !canvasState.refs.overlayRef.current
  ) {
    return null;
  }

  const contentRect = normalizeRectangle(
    selectionState.startPoint,
    selectionState.currentPoint
  );

  const rect = coordinates.rect.contentToViewport(transformCtx)(contentRect);

  return createPortal(
    <rect
      {...rect}
      fill="rgba(59, 130, 246, 0.1)"
      stroke="rgba(59, 130, 246, 0.8)"
      strokeWidth="2"
      strokeDasharray="4 4"
      pointerEvents="none"
    />,
    canvasState.refs.overlayRef.current
  );
};
